import type { PageCard } from '@/play/pageTypes'
import { MoonSlimeCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'moon-slime',
  number: 9,
  title: 'Moon slime',
  question: 'Gobs of slime on the moon.',
  status: 'open',
  accent: '#1b1f36',
  CardArt: MoonSlimeCardArt,
}
